var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1255_158073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.172 0C23.7022 0 24.2107 0.210507 24.5857 0.585255L36.4137 12.4044C36.7891 12.7795 37 13.2884 37 13.8191V35.3333C37 37.9107 34.8689 40 32.24 40H7.76C5.13112 40 3 37.9107 3 35.3333V4.66667C3 2.08934 5.13112 0 7.76 0H23.172Z",
    fill: "#8E33FF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1255_158073)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.1548 12.1381C35.4678 12.4537 35.2443 12.9902 34.7998 12.9902H29C26.4227 12.9902 24.0976 10.7233 24.0976 8.21031V2.20435C24.0976 1.75791 24.6382 1.53528 24.9526 1.85224L35.1548 12.1381Z",
    fill: "white",
    fillOpacity: 0.24,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.9233 16.7978V26.221C22.9233 26.5014 22.8279 26.751 22.6372 26.9697C22.4465 27.1885 22.2053 27.3582 21.9137 27.4787C21.622 27.5993 21.3317 27.6891 21.0429 27.748C20.754 27.8069 20.4833 27.8363 20.2309 27.8363C19.9786 27.8363 19.7079 27.8069 19.419 27.748C19.1301 27.6891 18.8399 27.5994 18.5482 27.4787C18.2566 27.3581 18.0154 27.1885 17.8247 26.9697C17.6339 26.751 17.5386 26.5014 17.5386 26.221C17.5386 25.9405 17.6339 25.6909 17.8247 25.4722C18.0154 25.2535 18.2566 25.0838 18.5482 24.9632C18.8399 24.8425 19.1301 24.7528 19.419 24.6939C19.7079 24.6351 19.9786 24.6056 20.2309 24.6056C20.8199 24.6056 21.3583 24.715 21.8463 24.9337V20.4157L15.3848 22.4097V28.3749C15.3848 28.6553 15.2894 28.9049 15.0987 29.1237C14.908 29.3424 14.6668 29.5121 14.3751 29.6327C14.0834 29.7532 13.7932 29.843 13.5043 29.9019C13.2154 29.9608 12.9448 29.9902 12.6924 29.9902C12.44 29.9902 12.1693 29.9608 11.8805 29.9019C11.5916 29.843 11.3013 29.7533 11.0097 29.6327C10.718 29.512 10.4768 29.3424 10.2861 29.1237C10.0954 28.905 10 28.6554 10 28.3749C10 28.0944 10.0954 27.8448 10.2861 27.6261C10.4768 27.4074 10.718 27.2377 11.0097 27.1171C11.3013 26.9965 11.5916 26.9067 11.8805 26.8478C12.1693 26.789 12.44 26.7595 12.6924 26.7595C13.2813 26.7595 13.8198 26.8689 14.3078 27.0876V18.9518C14.3078 18.7779 14.361 18.6195 14.4676 18.4764C14.5742 18.3334 14.7116 18.2338 14.8799 18.1778L21.8799 16.0239C21.9472 16.0015 22.0257 15.9902 22.1155 15.9902C22.3399 15.9902 22.5306 16.0688 22.6876 16.2258C22.8446 16.3829 22.9233 16.5735 22.9233 16.7978Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1255_158073",
    x: 22.0977,
    y: 1.70337,
    width: 15.2031,
    height: 15.2869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1255_158073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1255_158073",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1255_158073"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.0e73b3d9dd6f880055a5e4de3d7c9106.svg";
export { ForwardRef as ReactComponent };